import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MikrotikRoutingModule } from './mikrotik-routing.module';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { DataModule } from '../keepalive/components/data/data.module';
import { MikrotikDashboardPageComponent } from './pages/mikrotik-dashboard/mikrotik-dashboard.page';
import { ToolsModule } from '../tools/tools.module';
import { MatRowComponent } from '../tools/mat-row/mat-row.component';
import { MatColComponent } from '../tools/mat-col/mat-col.component';

@NgModule({
  declarations: [MikrotikDashboardPageComponent],
  imports: [CommonModule, MikrotikRoutingModule, MaterialModule, DataModule, ToolsModule, MatRowComponent, MatColComponent],
  exports: [],
})
export class MikrotikModule {}
